import { render } from "./ProsecutorChief.vue?vue&type=template&id=35473b5b"
import script from "./ProsecutorChief.vue?vue&type=script&lang=js"
export * from "./ProsecutorChief.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__